import { inject } from '@angular/core';
import {
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  ResolveFn
} from '@angular/router';
import { AppStateService } from 'shared/services/app-state/app-state.service';
import { switchMap } from 'rxjs';
import { FileService } from '../../services/files/file.service';


export const residentPhotosResolver: ResolveFn<any> =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const fileService = inject(FileService);
    const appState = inject(AppStateService);
    const facilityId = appState.get('currentFacilityId');
    const residentId = appState.get('currentResidentId');

    const photos = appState.get('residentPhotos');
    // this will prevent from fetching the photos again unless there is a page refresh
    if (photos && photos.length > 0) {
      return undefined;
    }
    if (residentId) {
      // fetch resident photos asynchronously
      fileService.getResidentPhotos({ residentId })
      .pipe(
        switchMap(photos => fileService.getPhotoObjects({ photos, facilityId, residentId}))
      )
      .subscribe(photos => {
        appState.set('residentPhotos', photos)
      });
    }
    return undefined;
  };
